export const COMPANY_NAME = process.env.REACT_APP_COMPANY_NAME || 'COMPANY NAME'

// Tost message default error
export const TOSTMESSAGE = 'No message available'
export const DEFAULT_ERROR_MSG = 'Can you please try again?'
export const DEFAULT_WARRNING_MSG = 'Warning !!'

export const MAX_API_CALL_SAME_TIME = 5

// Session invalidation: idle timeout in ms (15 minutes)
export const SESSION_IDLE_TIMEOUT_MS = 15 * 60 * 1000
